<template>
  <div class="profile-container">
    <img src="/images/user.svg" :alt="$t('menu_profile_alt')"/>
    <div v-if="getDecodedJWT">
      <div class="text-profile">{{ getDecodedUsername }}</div>
    </div>
  </div>
</template>

<script>
import { useLoginStore } from "../stores/login.js";
import { mapState } from "pinia";
export default {
  computed: {
    ...mapState(useLoginStore, ["getDecodedJWT", "getDecodedUsername"]),
  },
};
</script>

<style scoped>
.profile-container .text-profile {
  color: white;
  font-size: 15px;
}
</style>
